import { registerMutation, registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
const BASE_URL = 'multi-account/copy-manager/v1';
const BULK_ASSET_TO_PORTABLE_KEY_URL = `${BASE_URL}/key-convertor/bulk/asset-to-portable-key`;
const ASYNC_TASK_URL = `${BASE_URL}/tasks/copy-assets/async`;
export const getBulkAssetPortableKeysFieldName = 'portableKeys';
export const GET_PORTABLE_KEYS = registerQuery({
  fieldName: getBulkAssetPortableKeysFieldName,
  args: ['assetIds', 'portableType'],
  fetcher: ({
    assetIds,
    portableType
  }) => {
    return http.post(BULK_ASSET_TO_PORTABLE_KEY_URL, {
      data: {
        assetIds,
        portableType
      }
    });
  }
});
export const createSyncTaskFieldName = 'syncTask';
export const CREATE_ASSET_SYNC_TASK = registerMutation({
  fieldName: createSyncTaskFieldName,
  args: ['command', 'fromHubId', 'portableKeys', 'portableType', 'toHubId'],
  fetcher: ({
    command,
    fromHubId,
    portableKeys,
    portableType,
    toHubId
  }) => {
    return http.post(ASYNC_TASK_URL, {
      data: {
        toHubId,
        fromHubId,
        command,
        tasks: [{
          type: portableType,
          portableKeys
        }],
        forceTypes: false,
        syncOptions: {
          skipComponentValidation: false,
          skipLimitValidation: false
        }
      }
    });
  }
});
export const getTaskStatusFieldName = 'taskStatus';
export const GET_TASK_STATUS = registerQuery({
  fieldName: getTaskStatusFieldName,
  args: ['taskId'],
  fetcher: ({
    taskId
  }) => {
    return http.get(`portability-sync/v1/tasks/${taskId}`);
  }
});
export const getTargetHubsFieldName = 'targetHubs';
export const GET_TARGET_HUBS = registerQuery({
  fieldName: getTargetHubsFieldName,
  args: [],
  fetcher: () => {
    return http.get(`${BASE_URL}/target-hubs`);
  }
});